export { PhoneColumnComponent } from './phone-column.component';
